import Modal from "/WebInterface/new-ui/modules/modal.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import {
  getAllSubscribeReverseNotificationEvents,
  saveSubscribeReverseNotificationEvents,
} from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import store from "/WebInterface/new-ui/store/index.js";
import {
  subscribeEventsFileCardTemplate,
  subscribedEventsWrapperTemplate,
  permissionTextTemplate,
} from "/WebInterface/new-ui/modules/modals/manage-subscribed-events/template.js";
import { initSubscribeToEvents } from "/WebInterface/new-ui/modules/modals/subscribe-to-events/subscribe-to-events.js";
import { Confirm } from "/WebInterface/new-ui/modules/alert.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import { growl } from "/WebInterface/new-ui/modules/toast.js";

const renderSubscribeEvents = () => {
  const subscribedEvents = store.subscribedEvents;
  const subscribedEventsWrapper = _$("#subscribe-events-wrapper");

  subscribedEventsWrapper.html("");

  if (subscribedEvents.length === 0) {
    subscribedEventsWrapper.html(
      `<div class="is-flex is-justify-content-center is-align-items-center text-secondaryMain" style="height: 100%;">${t(
        "nothingToDisplay"
      )}</div>`
    );
  }
  subscribedEvents.forEach((event) => {
    const { path, privs } = event;
    const uid = utils.getUId();

    subscribedEventsWrapper?.el()?.insertAdjacentHTML(
      "beforeend",
      subscribeEventsFileCardTemplate({
        uid,
        path,
        privs,
        editText: t("edit"),
        deleteText: t("Delete"),
      })
    );

    const permissions = [
      { default_text: "(download)", i18n_key: "Download" },
      { default_text: "(upload)", i18n_key: "Upload" },
      { default_text: "(delete)", i18n_key: "Delete" },
      { default_text: "(rename)", i18n_key: "Rename" },
      { default_text: "(makedir)", i18n_key: "Create Folder" },
    ];

    permissions.forEach(({ default_text, i18n_key }) => {
      const hasPermission = privs.includes(default_text);

      if (hasPermission) {
        _$(`#${uid} .permissions-allowed`)
          ?.el()
          ?.insertAdjacentHTML(
            "beforeend",
            permissionTextTemplate({
              permissionText: t(i18n_key),
              permission: i18n_key,
            })
          );
      }
    });

    _$(`#${uid} .edit-button`).on("click", async () => {
      initSubscribeToEvents({
        href_path: path.substring(0, path.length - 1),
      });
      await fetchReverseNotificationDataAndStoreInRedux();
    });

    _$(`#${uid} .delete-button`).on("click", () => {
      Confirm({
        title: t("confirm"),
        body: t(`areYouSureYouWantToDeleteSubscribeEventsOfDirectory`, {
          path,
        }),
        confirm: t("yes"),
        cancel: t("no"),
      }).then(async (res) => {
        if (res) {
          const loader = new Loader({
            parentElement: "#subscribe-events-wrapper",
          });

          try {
            const result = await saveSubscribeReverseNotificationEvents({
              privs: "",
              path,
            });

            // Checking for the errors
            const response = result?.commandResult?.response;
            if (response?.toLowerCase()?.includes("error:")) {
              growl(utils.decodeURILocal(response), "", 5000, true);
              return;
            }

            await fetchReverseNotificationDataAndStoreInRedux();
            growl(
              t("subscribeEventsHasBeenDeleted"),
              t("success"),
              5000,
              false
            );
          } catch (error) {
            growl(error, "", 5000, true);
          } finally {
            loader.deleteLoader();
          }
        }
      });
    });
  });
};

export const initManageSubscribedEvents = async (path) => {
  new Modal({
    title: "Manage Subscribed Events",
    body: subscribedEventsWrapperTemplate({}),
    uniqueId: "manage-subscribed-events-modal",
    minHeight: "500px",
    minWidth: "800px",
    movable: true,
    animate: false,
    backdrop: false,
    extraClasses: ["manage-subscribed-events-modal"],
    buttons: [
      {
        label: "close",
        classes: ["primary-button", "is-bordered"],
        close: true,
        onClick: () => {},
      },
    ],
    onBeforeShow: async () => {
      await fetchReverseNotificationDataAndStoreInRedux();
    },
  });

  renderSubscribeEvents();
};

export const fetchReverseNotificationDataAndStoreInRedux = async () => {
  let notifications = [];

  try {
    const response = await getAllSubscribeReverseNotificationEvents();
    if (response?.commandResult?.response?.toLowerCase()?.includes("error:")) {
      growl(
        utils.decodeURILocal(response?.commandResult?.response),
        "",
        5000,
        true
      );
      return;
    }
    const data =
      response?.result?.response_data?.result_value?.result_value_subitem;

    notifications = data;
    if (data && !Array.isArray(data)) {
      notifications = [data];
    }
  } catch (error) {
    console.log(error);
  }

  store.dispatch("setAllSubscribeEvents", notifications);
};

const updateListingSubscribedEventBadges = () => {
  const subscribedEvents = store.subscribedEvents;
  _$(".subscribed-events-label").addClass("is-invisible");

  subscribedEvents.forEach(({ path, privs }) => {
    const href_path = path.substring(0, path.length - 1);
    const element = document.getElementById(
      `subscribed_events_${href_path}_label`
    );

    if (!element) {
      return;
    }

    const eventsCount = utils.countSubscribedEventsTags(privs);
    _$(element).text(eventsCount);
    _$(element).removeClass("is-invisible");
  });
};

export const manageSubscribedEventsStoreSubscribeEvents = [
  {
    eventName: "setAllSubscribeEvents",
    callback: (action, payload) => {
      renderSubscribeEvents();
      updateListingSubscribedEventBadges();
    },
  },
];
